import * as Yup from "yup";
import { MaterialInOutSourceType } from "features/MaterialInOuts/constants/material-in-out.constants";

const schema = Yup.object({
  materialId: Yup.number()
    .typeError("Material is required")
    .required("Material is required"),

  userId: Yup.number()
    .typeError("Concerned person is required")
    .required("Concerned person is required"),

  sourceType: Yup.mixed<MaterialInOutSourceType>()
    .oneOf(Object.values(MaterialInOutSourceType))
    .required("Source type is required"),

  /**
   * Required unless sourceType is OTHER. Transform first — an empty string
   * (the field's default/reset value while OTHER is selected) would otherwise
   * cast to NaN, which `.nullable()` does not treat as null.
   */
  sourceId: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? null : value,
    )
    .nullable()
    .when("sourceType", {
      is: MaterialInOutSourceType.OTHER,
      then: (s) => s.nullable(),
      otherwise: (s) =>
        s
          .typeError("The source field is required")
          .required("The source field is required"),
    }),

  /** Required when sourceType is OTHER. */
  otherDescription: Yup.string()
    .nullable()
    .when("sourceType", {
      is: MaterialInOutSourceType.OTHER,
      then: (s) => s.trim().required("Description is required"),
      otherwise: (s) => s.nullable(),
    }),

  quantity: Yup.number()
    .typeError("Enter a valid quantity")
    .positive("Quantity must be greater than zero")
    .required("Quantity is required"),

  dateOut: Yup.string().nullable(),
});

export default schema;
